import React, {useCallback, useState, useEffect} from "react";
import {uniqueId} from "lodash";

import {format} from 'date-fns'
import {format as timezone} from 'date-fns-tz';
import {useQuery, useQueryClient} from "react-query";
import {toast} from "react-toastify";

import Upload from "components/Dropzone"

import DocumentsList from 'components/DocumentsList';
import PaginationTable from "components/Pagination";
import Loading from "components/Loading";

import {getDocuments} from "services/Files.service";
import {useUser} from "store/providers/app";

import api from "services/api";
import {i18n} from "translate/i18n";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {Field} from "formik";
import {categoriesPt, categoriesEn} from './actions';

import {setLog} from 'services/Logs.service'


const DocumentFiles = ({param}) => {

    const {user, language} = useUser();

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginate, setPaginate] = useState([]);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState('');

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('');
    const [lang, setLanguage] = useState(language);

    const [files, setFiles] = useState([])
    const [categories, setCategories] = useState([])

    useEffect(() => {
        if(lang === 'en-US') {
            setCategories(categoriesEn)
        } else {
            setCategories(categoriesPt)
        }
    }, [lang])

    const {isLoading, isFetching} = useQuery([param, currentPage, filter],
        () => {
            return getDocuments(filter, currentPage)
        }, {
            onSuccess: (res) => {
                const {data} = res

                setPaginate({
                    from: data.from,
                    to: data.to,
                    total: data.total
                })

                dataFiles(data.data);
            },
            onError: (err) => {
                toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        })


    const dataFiles = (response) => {
        setUploadedFiles(
            response.map(file => (
                {
                    id: file.id,
                    filename: file.filename,
                    created_at: format(new Date(file.created_at), 'dd/MM/yyyy - HH:mm'),
                    language: file.language,
                    category: file.category,
                    title: file.title,
                    description: file.description,
                    username: file.username,
                    uploaded: true,
                    url: file.url,
                    path: file.filepath
                }
            ))
        );
    }

    const handleUpload = files => {

        const znDate = timezone(new Date(), 'dd/MM/yyyy - HH:mm', {
            timeZone: 'America/Sao_Paulo',
        });

        const newFile = files.map(file => ({
            file,
            id: uniqueId("arch_"),
            filename: file.name,
            created_at: znDate,
            category: category,
            language: lang,
            title: title,
            description: description,
            username: user.username,
            progress: 0,
            uploaded: false,
            error: false,
            url: "",
        }))

        setUploadedFiles((state) => state.concat(newFile))
        setFiles(newFile)

    };
    const clientQuery = useQueryClient()

    const updateFile = useCallback((id, data) => {
        setUploadedFiles((state) =>
            state.map((file) => (file.id === id ? {...file, ...data} : file))
        );
        clientQuery.invalidateQueries(['documents', currentPage, filter])
    }, []);

    const processUpload = (uploadedFile) => {


        //console.log('uploadedFile', uploadedFile)
       // return

        const data = new FormData();
        data.append('file', uploadedFile.file, uploadedFile.filename);
        data.append('username', uploadedFile.username);
        data.append('title', uploadedFile.title);
        data.append('description', uploadedFile.description);
        data.append('category', uploadedFile.category);
        data.append('language', uploadedFile.language);

        api.post(`/documents`, data, {
            onUploadProgress: e => {
                const progress = parseInt(Math.round((e.loaded * 100) / e.total));
                updateFile(uploadedFile.id, {progress});
            }

        }).then((response) => {
            updateFile(uploadedFile.id, {
                uploaded: true,
                id: response.data.document.id,
                url: response.data.document.url,
            });

            setLog({
                'title': 'UPLOAD_DOCUMENT',
                'description': 'Upload de arquivo: ' + uploadedFile.filename,
                'username': uploadedFile.username,
            });

        }).catch((err) => {
            updateFile(uploadedFile.id, {
                error: true,
            });
        });
    };

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    const handleSearch = () => {
        setFilter(search);
    }

    const clearInput = () => {
        setFilter('');
        setSearch('');
    }

    const handleNewUpload = () => {
        files.forEach(processUpload)
    }

    const handleDeleteNew = (position, id) => {
        setUploadedFiles([...uploadedFiles.filter((item, index) => index !== position)])
        setFiles([...files.filter((item, index) => item.id !== id)])
    }

    return (
        <>
            <div className="card my-3 border-0 shadow-sm">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="form-label">{i18n.t('label.language')}</label>
                                    <select className="form-select" name="language" onChange={(e) => setLanguage(e.target.value)}>
                                        <option value="pt-BR">Português</option>
                                        <option value="en-US">Inglês</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label">{i18n.t('label.category')}</label>
                                        <select className="form-select"  onChange={(e) => setCategory(e.target.value)}>
                                            <option value=''>{i18n.t('label.select')}</option>
                                                {
                                                    categories.map((item, index) =>
                                                    <option key={index}>{item}</option>
                                                    )
                                                }
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="form-label">{i18n.t('label.title')}</label>
                                <input className="form-control" onChange={(e) => setTitle(e.target.value)}/>
                            </div>
                            <div className="form-group">
                                <label className="form-label">{i18n.t('label.description')}</label>
                                <textarea className="form-control" onChange={(e) => setDescription(e.target.value)}/>
                            </div>
                        </div>
                        <div className="col-md-8 mt-4">
                            <Upload onUpload={handleUpload}/>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-12 text-end">
                            <button type="button" className="btn btn-success" onClick={() => handleNewUpload()}>
                                {i18n.t('label.sendFiles')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            {isLoading ? <Loading/> :

                <div className="card border-0 shadow-sm">
                    <div className="card-header bg-light text-uppercase shadow-sm">
                        <div className="row py-2">
                            <div className="col-4 mt-2 fs-5">{i18n.t('label.archives')}</div>
                            <div className="col-6 ms-auto">
                                <div className="input-group">
                                    <input
                                        className="form-control"
                                        onChange={(e) => setSearch(e.target.value)}
                                        placeholder={i18n.t('placeholder.searchDocuments')}
                                        value={search}
                                    />
                                    {filter !== '' &&
                                        <OverlayTrigger overlay={<Tooltip
                                            id="tooltip-disabled">{i18n.t('label.cleanFilter')}</Tooltip>}>
                                            <button className="btn btn-outline-danger bi-x-circle"
                                                    onClick={() => clearInput()}/>
                                        </OverlayTrigger>
                                    }
                                    <OverlayTrigger
                                        overlay={<Tooltip id="tooltip-disabled">{i18n.t('label.search')}</Tooltip>}>
                                        <button type="button"
                                                className={`btn btn-outline-primary bi-search ${search.length < 3 && 'disabled'}`}
                                                onClick={() => handleSearch()}/>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-body p-0 table-responsive">
                        <DocumentsList
                            files={uploadedFiles}
                            isFetching={isFetching}
                            currentPage={currentPage}
                            search={filter}
                            handleDeleteNew={handleDeleteNew}
                        />
                    </div>
                    <div className="card-footer border-top-0 bg-white">
                        <PaginationTable
                            isFetching={isFetching}
                            paginate={paginate}
                            handlePageClick={handlePageClick}
                        />
                    </div>
                </div>
            }
        </>
    );
}

export default DocumentFiles;

